module.exports = __webpack_public_path__ + "img/beispielfalsch.3927a77c.gif";